// libs
import axios, { AxiosResponse } from 'axios';
// App
import { Reservation } from '../reservation.interface';
import { CreateReservationParam } from '../create-reservation-param.interface';
import { buildKeyUrl, buildReservationsUrl } from '../shop/reservation-urls.utils';

export const createReservation = (param: CreateReservationParam): Promise<AxiosResponse<Reservation>> => {
  return axios.post(buildReservationsUrl(), param);
};

export const getReservationByKey = (key: string): Promise<AxiosResponse<Reservation>> => {
  return axios.get(`${buildReservationsUrl()}/by-key/${encodeURIComponent(key)}`);
};

export const cancelReservationByKey = (key: string): Promise<AxiosResponse<Reservation>> => {
  return axios.post(buildKeyUrl('cancel', key));
};

export const reconfirmReservationByKey = (key: string): Promise<AxiosResponse<Reservation>> => {
  return axios.post(buildKeyUrl('reconfirm', key));
};
